module.exports = __webpack_public_path__ + "img/day07.3f4ec14c.png";